<script setup>

import PriceFormatter from "@/components/PriceFormatter.vue";
import {UseMoneyStore} from "@/stores/moneyStore";
import {useOrderDataStore} from "@/stores/orderDataStore";
import {useI18n} from "vue-i18n";

const { t } = useI18n();
const moneyStore = UseMoneyStore();
const orderDataStore = useOrderDataStore();

</script>

<template>
  <div class="flex items-start space-x-9 responsive-body-small">
    <div>
      <span class="block font-bold responsive-body-medium">{{ t('refund.title') }}</span>
      <span v-if="orderDataStore.shippingCountry==='GR'" class="text-bw-lightDarkGrey block">
        
         
        {{ t('refund.grDescription') }} <br>
        <strong>{{ t('returnCost') }}: <PriceFormatter :price="orderDataStore.serviceCost.toString()"/></strong>, {{ t('autoRemoved') }}<br><br>

        <span class="text-bw-black block">
          IBAN: {{moneyStore.fullIban()}} <br>
          {{ t('name') }}: {{moneyStore.beneficiaryName}}
        </span>
      </span>
      <span v-if="orderDataStore.shippingCountry==='CY'" class="text-bw-lightDarkGrey block mt-2">
        <span class="text-bw-black block">
          IBAN: {{moneyStore.fullIban()}} <br>
          {{ t('refund.name') }}: {{moneyStore.beneficiaryName}}
        </span>
      </span>
    </div>
  </div>
</template>

<style scoped>

</style>